import { render } from "./ReturnPolicy.vue?vue&type=template&id=080d9c08&scoped=true"
import script from "./ReturnPolicy.vue?vue&type=script&lang=js"
export * from "./ReturnPolicy.vue?vue&type=script&lang=js"

import "./ReturnPolicy.vue?vue&type=style&index=0&id=080d9c08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080d9c08"]])

export default __exports__